import { registerLocaleData } from '@angular/common';
import localeNb from '@angular/common/locales/nb';
import { bootstrapApplication } from '@angular/platform-browser';
import posthog from 'posthog-js';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

// Register Norwegian locale data for Angular pipes (currency, date, number)
registerLocaleData(localeNb, 'nb-NO');

// Initialize PostHog before Angular bootstrap so it captures the initial
// API call and render. posthog.init() is non-blocking.
if (environment.posthog.apiKey && environment.posthog.apiKey !== 'phc_PLACEHOLDER') {
  posthog.init(environment.posthog.apiKey, {
    api_host: environment.posthog.apiHost,
    capture_pageview: true,
    capture_pageleave: true,
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: '[data-ph-mask]',
    },
  });
}

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
